import React from 'react';
import StarRatings from 'react-star-ratings';
import { getData } from '../utils';

export default class ProductReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reviews: [],
        };
        this.getData = getData.bind(this);
    }

    componentDidMount() {
        let reviewSearch = {
            dataDesc: {
                limit: 1,
            },
            productId: this.props.prodId,
            f: 'getReviewsPerProduct',
            s: process.env.REACT_APP_STORE,
        };
        this.getReviews(reviewSearch);
    }

    getReviews = (reviewSearch) => {
        (async () => {
            try {
                let content = await this.getData('konakartjson', reviewSearch);
                if (content.r.totalNumReviews > 0)
                    this.setState({ reviews: content.r.reviewArray });
            } catch (err) {
                console.log(err);
            }
        })();
    };

    render() {
        if (this.state.reviews.length > 0) {
            let review = this.state.reviews[0];
            return (
                <div className="review">
                    {review.custom1 === 'hide_stars' ? (
                        ''
                    ) : (
                        <StarRatings
                            rating={review.rating}
                            starDimension="33px"
                            starSpacing="5px"
                            starRatedColor="#e85607"
                        />
                    )}
                    <div
                        className={'review-text'}
                        dangerouslySetInnerHTML={{ __html: review.reviewText }}
                    />
                </div>
            );
        } else return null;
    }
}
